import { createRouter, type RouterHistory } from '@tanstack/react-router';
import type { Authenticator } from '../features/auth/authenticator';
// Generated from the files in src/routes/ by the router's Vite plugin (vite.config.ts).
import { routeTree } from '../routeTree.gen';
import { NotFound } from '../shared/components/NotFound';
import { PageLoading } from '../shared/components/PageLoading';
import { UnexpectedError } from '../shared/components/UnexpectedError';

/** `history` defaults to the browser's; tests pass a memory history. */
export function createAppRouter(authenticator: Authenticator, history?: RouterHistory) {
  return createRouter({
    routeTree,
    context: { authenticator },
    ...(history ? { history } : {}),
    defaultPreload: 'intent',
    // A page still loading its code after `defaultPendingMs` (1 s) shows this, rather
    // than an empty page, for at least `defaultPendingMinMs` (0.5 s) (D-073).
    defaultPendingComponent: PageLoading,
    // The router's built-in fallbacks are English-only; ours are translated.
    defaultNotFoundComponent: NotFound,
    defaultErrorComponent: UnexpectedError,
  });
}

export type AppRouter = ReturnType<typeof createAppRouter>;

declare module '@tanstack/react-router' {
  interface Register {
    router: AppRouter;
  }
}
